<template>
  <v-tooltip
    :disabled="!isDisabled"
    location="bottom"
  >
    <template v-slot:activator="{ props }">
      <div
        :class="{ 'w-full': $vuetify.display.xs }"
        class="px-2 my-2"
        v-bind="props"
      >
        <v-btn
          :disabled="isDisabled"
          color="primary"
          class="camel-case w-full"
          @click="click"
        >
          <v-icon
            size="small"
            start
          >
            {{ icon }}
          </v-icon>
          {{ label }}
        </v-btn>
      </div>
    </template>
    <span>{{ $t('acquisition-booster.description') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  methods: {
    click() {
      this.$emit('click')
    },
  },
}
</script>
